import { inspectSummary } from './pdfSummary.js';

export function inspectReportType(pdf) {
  const pages = [];
  for (let index = 0; index < Math.min(3, pdf.getPageCount()); index += 1) {
    pages.push(
      inspectSummary(pdf, index)
        .lines.map((line) => line.sentence)
        .join(' ')
    );
  }
  const text = pages.join(' ').replace(/\s+/g, ' ');
  if (/\bAECG\s+Summary\s+Report\b/i.test(text)) return 'holter';
  if (/\bMCT\b|Mobile\s+Cardiac\s+Telemetry/i.test(text)) return 'mct';
  if (/\bEvent\s+(?:Monitor\s+)?Report\b|\bSingle\s+Episode\s+Report\b/i.test(text)) return 'event';
  return 'unknown';
}

export function requireHolterReport(pdf) {
  const type = inspectReportType(pdf);
  if (type === 'mct' || type === 'event') {
    throw new Error(
      `Skipped: this is an ${type === 'mct' ? 'MCT' : 'Event'} report, not an AECG Holter Summary Report. HR Trend and Strip Index were not inserted.`
    );
  }
  if (type === 'unknown') {
    throw new Error(
      'Skipped: AECG Summary Report heading was not found on the first three pages. Report type is unknown; it may be Event/MCT or an unsupported PDF.'
    );
  }
}
